var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.28ab2604b3e01ee6a5f79b69829afa28.svg#close-slim';
                    var viewUrl = 'svg/global.28ab2604b3e01ee6a5f79b69829afa28.svg#view-close-slim';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };